export const slugify = (name: string) => {
  return name
    .toLowerCase()
    .trim()
    .replace(/\.|\+|%|\(|\)|!|'g/, "")
    .split(" ")
    .join("-");
};
